import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Authentication from "../../../componant/authentication/authentication";
import { Riple } from "react-loading-indicators";

import LearnPlan from "../userPanal/Plans/LearnPlan";
import Checkoutpage from "../userPanal/Plans/Checkoutpage";
import Maincontest from "../userPanal/contest/Maincontest";
import Wallet from "../wallet/Wallet";
import StartQuizepage from "../userPanal/Mcq/StartQuizepage";
import QuestionPage from "../userPanal/Mcq/QuestionPage";
import DashHome from "../userPanal/dashhome/DashHome";
import ContestQuestion from "../userPanal/contestMCQ/ContestQuestion";
import WinnersPage from "../userPanal/contest/WinnersPage";
import WithDrawHistory from "../withdraw/WithHistory";
import ContestWallet from "../wallet/ContestWallet";
import ContestWithDrawHistory from "../withdraw/ContestWithHistory";
import ReferralWallet from "../wallet/ReferralWallet";
import StartQuizepage2 from "../userPanal/Mcq/StartQuizepage2";

import ContestResultPage from "../userPanal/contest/ContestResultPage";
import WithdrawalHistory from "../wallet/WithdrawalHistory";
import ReferralPage from "../referral/ReferralPage";

const DashRoute = () => {
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust timeout as needed

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <Authentication>
        {/* {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
            <Riple color="#000000" size="medium" text="" textColor="" />
          </div>
        )} */}
        <Routes>
          {/* <Route path='/home' element={<MainMcqs />} /> */}
          <Route path="/home" element={<DashHome />} />
          <Route path="/quize" element={<QuestionPage />} />
          <Route path="/plan" element={<LearnPlan />} />
          <Route path="/checkout/:id" element={<Checkoutpage />} />
          <Route path="/contest" element={<Maincontest />} />
          <Route path="/contest-question" element={<ContestQuestion />} />
          <Route path="/contest-winner" element={<WinnersPage />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/contest-wallet" element={<ContestWallet />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route path="/referral-wallet" element={<ReferralWallet />} />
          <Route path="/withdrawal-history" element={<WithdrawalHistory />} />

          <Route path="/withdraw-history" element={<WithDrawHistory />} />
          <Route
            path="/contest-withdraw-history"
            element={<ContestWithDrawHistory />}
          />
          {/* <Route path='/start-quize' element={<StartQuizepage />} /> */}
          <Route path="/start-quize" element={<StartQuizepage2 />} />
          <Route path="/contest-result" element={<ContestResultPage/>} />

          <Route path="*" element={<Navigate to="/dash/home" replace />} />
        </Routes>
      </Authentication>
    </>
  );
};

export default DashRoute;
